import React from 'react';
import { DocRenderer } from '@cyntler/react-doc-viewer';

const UnsupportedViewer: DocRenderer = ({ mainState: { currentDocument } }) => {
  const fileName = currentDocument?.fileName || 'file';
  const fileType = currentDocument?.fileType || 'unknown';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '300px', color: '#6c757d' }}>
      <i className="bi bi-file-earmark-x" style={{ fontSize: '3rem', marginBottom: '1rem' }}></i>
      <div className="fw-semibold mb-1">Preview not available</div>
      <div className="small mb-3">No viewer for .{fileType} files</div>
      {currentDocument?.uri && (
        <a href={currentDocument.uri} download={fileName} className="btn btn-sm btn-outline-primary">
          <i className="bi bi-download me-1"></i>Download to view
        </a>
      )}
    </div>
  );
};

// File types where built-in renderers fail (e.g. require public URLs) or produce bad results
UnsupportedViewer.fileTypes = ['doc', 'application/msword'];
UnsupportedViewer.weight = 2;

export default UnsupportedViewer;
